import { TABLES } from "../db";
import { BaseLocalRepository } from "./BaseLocalRepository";

export class LocalAuditRepository extends BaseLocalRepository {
  constructor(db) {
    super(db, TABLES.AUDIT_ENTRIES);
  }

  async listByEntity(entityType, entityId) {
    return this.table.where("[entityType+entityId]").equals([entityType, entityId]).toArray();
  }
}
